import { render, staticRenderFns } from "./ReporteVacaciones.vue?vue&type=template&id=c64ee0ea"
import script from "./ReporteVacaciones.vue?vue&type=script&lang=js"
export * from "./ReporteVacaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports